/** Quick replies for Business WhatsApp Web: CRM-managed text only. Fill placeholders from explicit context,
 *  never guess. Nothing is sent; the user copies the text or opens one wa.me chat themselves. */
import { contactWhatsApp } from "@/lib/whatsappLinks";

const TOKEN = /\{([a-z_]+)\}/g;

export function placeholdersIn(body) {
  return [...new Set([...(body || "").matchAll(TOKEN)].map((m) => m[1]))];
}

/** Replace {tokens} with trimmed, non-empty values; report every token that still has no value. */
export function fillQuickReply(body, values = {}) {
  const missing = placeholdersIn(body).filter((k) => !String(values[k] ?? "").trim());
  const text = (body || "").replace(TOKEN, (m, k) => (String(values[k] ?? "").trim() ? String(values[k]).trim() : m));
  return { text, missing };
}

/** Context the CRM can vouch for: the visible contact and the signed-in staff member. Nothing else is inferred. */
export function contextValues(contact, user) {
  const v = {};
  if (contact?.name) v.contact_name = contact.name;
  if (contact?.company) v.customer_name = contact.company;
  if (user?.name) v.staff_name = user.name;
  return v;
}

/** One wa.me chat for one eligible contact, with the reviewed text pre-filled. Same eligibility rules as Open in WhatsApp. */
export function quickReplyLink(contact, text) {
  const s = contactWhatsApp(contact);
  if (!s.ok) return s;
  if (!String(text || "").trim()) return { ok: false, reason: "Write or choose a message first." };
  return { ok: true, url: `${s.url}?text=${encodeURIComponent(text)}` };
}
